<nav mat-tab-nav-bar>
  <a mat-tab-link *ngFor="let link of links"
     [routerLink]="link.path"
     routerLinkActive #rla="routerLinkActive"
     [active]="rla.isActive">
    {{link.label}}
    <mat-icon *ngIf="link.recommended" class="color-green recommended-icon"
              matTooltip="Recommended"
              i18n-matTooltip="General|Recommended label@@general-recommended-label">new_releases
    </mat-icon>
  </a>
</nav>
<div class="content">
  <router-outlet></router-outlet>
</div>
